import $ from 'jquery'
import batchModalTemplate from 'templates/batch/search.pug'
import storeBatchTemplate from 'templates/store/batch.pug'

import Modal from 'garden/src/js/components/modal'

import componentLoader from 'scripts/component-loader'
import BaseComponent from 'scripts/components/base-component'

class BatchTrigger extends BaseComponent {
  static componentName = 'batch-trigger'

  static DOMEvents = {
    click: 'onElementClick'
  }

  constructor (element, options = {}) {
    super(element)

    this.options = options
  }

  onElementClick () {
    this.unsetModal()
    this.setModal()
  }

  setModal () {
    const { lm, storeSlug, limit } = this.options

    this.$modal =
      $(batchModalTemplate({ lm, storeSlug, limit }))
        .append(storeBatchTemplate({ lm, storeSlug }))
        .modal()
        .data('modal')

    this.setModalComponents()
    this.showModal()
  }

  showModal () {
    this.$modal.show()
  }

  setModalComponents () {
    const { $content } = this.$modal

    componentLoader($content.find('[data-component]'))
  }

  unsetModal () {
    if (this.$modal) {
      this.$modal.destroy()
    }
  }
}

export default ($el) => new BatchTrigger($el, $el.data())

export { BatchTrigger as Component }
